import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProofPageableResponse } from '@app-model/proofs';
import { environment } from '@env/environment';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { FilterOptions } from './../model/filter';

@Injectable({
	providedIn: 'root'
})
export class ProofsService {
	constructor(private http: HttpClient, private toastr: ToastrService) {}

	paginate(filter: FilterOptions): Observable<ProofPageableResponse> {
		return this.http
			.post(`${environment.api}/admin-proof/list`, filter)
			.pipe(map((response: ProofPageableResponse) => response));
	}

	getUserProofsReportCsv(filter: FilterOptions) {
		return this.http.post(`${environment.api}/admin-proof/csv/download`, filter, {
			responseType: 'blob'
		});
	}

	getProofsReportZipCsv(proof: string[]) {
		return this.http.post(`${environment.api}/admin-proof/proof/download`, proof, {
			responseType: 'blob'
		});
	}

	getProofDayOfWeek(payload): Observable<any> {
		return this.http.post(`${environment.api}/health/proof/dashboardProofDayOfWeek`, payload);
	}

	getProofTimeout(payload): Observable<any> {
		return this.http.post(`${environment.api}/health/proof/dashboardProofTimeout`, payload);
	}

	getProofMonthly(payload): Observable<any> {
		return this.http.post(`${environment.api}/health/proof/dashboardProofMonthly`, payload);
	}

	getCidChapter(payload): Observable<any> {
		return this.http.post(`${environment.api}/health/proof/dashboardCidChapter`, payload);
	}

  getFileProof(proofId, id) {
    return this.http.get(
      `${environment.api}/health/proof/file/${proofId}/${id}`,
      {
        responseType: 'arraybuffer',
      }
    );
  }
}
